var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBaselineHelpOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41602 11.9997H7.58268V10.6663H6.41602V11.9997ZM6.99935 1.33301C3.77935 1.33301 1.16602 4.31967 1.16602 7.99967C1.16602 11.6797 3.77935 14.6663 6.99935 14.6663C10.2193 14.6663 12.8327 11.6797 12.8327 7.99967C12.8327 4.31967 10.2193 1.33301 6.99935 1.33301ZM6.99935 13.333C4.42685 13.333 2.33268 10.9397 2.33268 7.99967C2.33268 5.05967 4.42685 2.66634 6.99935 2.66634C9.57185 2.66634 11.666 5.05967 11.666 7.99967C11.666 10.9397 9.57185 13.333 6.99935 13.333ZM6.99935 3.99967C5.71018 3.99967 4.66602 5.19301 4.66602 6.66634H5.83268C5.83268 5.93301 6.35768 5.33301 6.99935 5.33301C7.64102 5.33301 8.16602 5.93301 8.16602 6.66634C8.16602 7.99967 6.41602 7.83301 6.41602 9.99967H7.58268C7.58268 8.49967 9.33268 8.33301 9.33268 6.66634C9.33268 5.19301 8.28852 3.99967 6.99935 3.99967Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaselineHelpOutline);
export default __webpack_public_path__ + "static/media/baseline-help-outline.ddbe69e5ee17822ba3bb88004dd0ed20.svg";
export { ForwardRef as ReactComponent };